module.exports = __webpack_public_path__ + "static/cfci_logo@2x-93f3b7e8e1a1f0754d4b833031dd9a60.png";